import { Divider as Divider$1 } from '@cbhq/cds-web/layout/Divider';
import { jsx } from 'react/jsx-runtime';
const Divider = () => {
  return function divider() {
    return /*#__PURE__*/jsx(Divider$1, {
      color: "line"
    });
  };
};
export { Divider };
//# sourceMappingURL=Divider.js.map
